module.exports = __webpack_public_path__ + "img/coinbankB37.ab618f00.jpg";